<template>
  <div ref="formRoot" class="container main__confirmation main--sticky-bottom">
    <div
      id="confirmation-summary"
      :class="{ additionalPaddingTop: isStickySelectContainer }"
      class="summary"
    >
      <div class="summary__header">
        <img :src="this.cruiseBannerUrl" />
        <div class="summary__header__info">
          <el-row justify="space-between" type="flex">
            <div class="summary__cruise-name">
              {{ cabinConfigurations[0] ? cabinConfigurations[0].ship : "" }}
            </div>
            <div class="summary__booking-number">
              <div class="summary__booking-number__label">Booking number</div>
              <div class="summary__booking-number__value">
                {{ booking.bookingCode }}
              </div>
            </div>
          </el-row>
        </div>
      </div>

      <div v-if="contacts.length > 3">
        <div
          :class="{ sticky: isStickySelectContainer }"
          class="select-container"
        >
          <label>Select a guest</label>
          <v-select
            :clearable="false"
            :get-option-label="getFullName"
            :options="contacts"
            :value="contacts[activeTabName]"
            filterable
            label="contactID"
            style="width: 33%"
            @input="onSelectContact($event)"
          >
          </v-select>
        </div>

        <contact-summary
          :contact="contacts[activeTabName]"
          :contactBooking="contactBooking(activeContactID)"
          :index="activeTabName"
          :isLastContact="activeTabName === contacts.length - 1"
          :onClickNextGuest="onClickNextGuest"
        />
      </div>

      <el-tabs v-else :value="'' + activeTabName" @tab-click="onClickTab">
        <el-tab-pane
          v-for="(contact, index) in contacts"
          :key="index"
          :name="'' + index"
        >
          <div slot="label" class="tab-pane__label">
            <div class="tab-pane__guest-wrapper">
              <div class="tab-pane__guest-index">
                {{ `Guest ${index + 1}` }}
              </div>
              <div class="tab-pane__guest-name">
                {{ getFullName(contact) | formatDisplay }}
              </div>
            </div>
          </div>
          <contact-summary
            :contact="contact"
            :contactBooking="contactBooking(activeContactID)"
            :index="index"
            :isLastContact="index === contacts.length - 1"
            :onClickNextGuest="onClickNextGuest"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="confirm-details">
      <el-form
        id="confirm-details-radio"
        ref="formValidate"
        :model="booking"
        :rules="ruleValidate"
      >
        <el-form-item prop="checkedInConfirmedBy">
          <el-radio-group
            :value="booking.checkedInConfirmedBy"
            @input="onCheckedConfirmedBy($event)"
          >
            <el-radio label="Guest" style="display: block; margin-top: 48px">
              <div class="confirm-details__label">
                I confirm that all my/our personal details are correct.
              </div>
            </el-radio>
            <el-radio
              label="Agent"
              style="display: block; margin-left: 0; margin-top: 22px"
            >
              <div class="confirm-details__label">
                I am an agent and I confirm that my guests' personal details are
                correct.
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <hr />
        <el-form-item prop="termsChecked">
          <el-checkbox
            v-model="termsChecked"
            true-label="true"
            false-label="false"
            class="confirm-details__label"
          >
            I have read and accept the
            <span
              v-html="checkGuestOrAgent(booking.checkedInConfirmedBy)"
            ></span
            >.
          </el-checkbox>
        </el-form-item>
      </el-form>
    </div>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          :disabled="isSaving"
          class="button--secondary bottom-nav__secondaryButton"
          @click="onClickBack()"
          >Back</el-button
        >
        <autosave-indicator></autosave-indicator>
        <el-button
          :disabled="isSaving"
          class="button--tertiary bottom-nav__secondaryButton"
          @click="setIsVisibleDialogSaveAndExit(true)"
          >Save
        </el-button>
        <el-button
          :disabled="isSaving"
          class="button--primary bottom-nav__primaryButton"
          @click="onClickNext()"
          >Next
        </el-button>
      </el-row>
    </div>

    <el-dialog
      :visible="this.isVisibleDialogError"
      class="dialog--error"
      show-close
      @close="isVisibleDialogError = false"
    >
      <div>
        Please note that one or more required fields for guest(s) are missing.
        Please select the guest’s name(s) to fill in all the required
        information.
      </div>
      <el-tree
        :data="contactNamesWithEmptyFields"
        :props="defaultTreeProps"
        class="summary__missing-field-tree"
      ></el-tree>

      <!--<ul class="summary__contact-list">-->
      <!--<li v-for="(contact, index) in contactNamesWithEmptyFields" class="summary__contact-list-item">-->
      <!--<span class="summary__contact-list-item-content">{{ `${index + 1}. ${contact.name}` }}</span>-->
      <!--<ul class="summary__contact-field-list">-->
      <!--<li v-for="(emptyField, index) in contact.fields" class="summary__contact-field-list-item">-->
      <!--<span class="summary__contact-field-list-item-content">{{ `${index + 1}. ${emptyField}` }}</span>-->
      <!--</li>-->
      <!--</ul>-->
      <!--</li>-->
      <!--</ul>-->
      <el-button
        style="margin: 0 auto; display: block"
        type="primary"
        @click="isVisibleDialogError = false"
        >Go back and edit
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import contactMixin from "../mixins/contact";
import { TYPE_OF_ARRANGEMENTS, UNHANDLED_ERROR_MESSAGE } from "../constants";
import VueScrollTo from "vue-scrollto";
import ContactSummary from "./ContactSummary";
import { timeTrack } from "../mixins/timeTrack";
import autosave from "../mixins/autosave";
import AutosaveIndicator from "./AutosaveIndicator";
import startCase from "lodash.startcase";

const DELIMITER = ";";
const typeOfArrangementMap = TYPE_OF_ARRANGEMENTS.reduce(
  (accumulate, current) => {
    accumulate[current.value] = current.label;
    return accumulate;
  },
  {},
);

export default {
  components: { VueScrollTo, ContactSummary, AutosaveIndicator },
  mixins: [contactMixin, timeTrack, autosave],
  created() {
    gtag("set", "page_path", "/step-5");
    gtag("event", "page_path", {
      path: "/step-5",
    });
  },
  data() {
    const contacts = this.$store.getters["contacts"];
    const booking = this.$store.getters["booking"];
    booking['termsChecked'] = false;
    //
    // // Creates a local model in order for Select multiple component to work
    // // actual update state is done in onContactInputChange
    // const modelSelectedDietaryPreferences = contacts.reduce((accumulate, current) => {
    //   accumulate[current.contactID] = current.dietaryPreferences ? current.dietaryPreferences.split(DELIMITER) : []
    //   return accumulate
    // }, {})
    //
    // const modelSelectedDietaryAllergies = contacts.reduce((accumulate, current) => {
    //   accumulate[current.contactID] = current.dietaryAllergies ? current.dietaryAllergies.split(DELIMITER) : []
    //   return accumulate
    // }, {})

    const validateTrueOnly = (rule, value, callback) => {
      if (this.termsChecked !== 'true') {
        callback(new Error("Please ensure that the you have read and accepted the terms and conditions"));
      } else {
        callback();
      }
    }

    const validationConfig = (message = '', trigger = 'blur') => {
      return {
        required: true,
        message: message || "Required",
        trigger: trigger,
      };
    }

    return {
      activeTabName: 0,
      activeContactID: contacts[0].contactID,
      typeOfArrangementMap,
      ruleValidate: {
        checkedInConfirmedBy: [validationConfig()],
        termsChecked:[{
          validator: validateTrueOnly,
        }]
      },
      // collapseIndex: '0',
      // selectDietaryPreferences: DIETARY_PREFERENCES,
      // selectDietaryAllergies: DIETARY_ALLERGIES,
      // modelSelectedDietaryPreferences,
      // modelSelectedDietaryAllergies,

      selectContainer: null,
      selectContainerOffsetTop: 0,
      isStickySelectContainer: false,

      isVisibleDialogError: false,
      contactNamesWithEmptyFields: [],
      defaultTreeProps: {
        children: "children",
        label: "label",
      },
      termsChecked: "false",
      booking
    };
  },
  mounted() {
    this.initializeAutosave(undefined, this.$refs.formRoot);
    if (this.contacts.length > 3) {
      this.selectContainer = document.querySelector(".select-container");
      this.selectContainerOffsetTop =
        this.selectContainer && this.selectContainer.offsetTop;
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  computed: {
    ...mapGetters([
      types.getters.cabinConfigurations,
      types.getters.contacts,
      types.getters.contactBookings,
      types.getters.contactBooking,
      types.getters.contact,
      types.getters.visaRequirements,
      types.getters.passports,
      types.getters.preArrangements,
      types.getters.postArrangements,
      types.getters.visaRequirementByContactID,
      types.getters.preArrangementByContactIDAndCategory,
      types.getters.postArrangementByContactIDAndCategory,
      types.getters.isSaving,
    ]),
    cruiseBannerUrl() {
      return `https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/cruise-banner/cruise-banner-${this.booking.facilityCode}.jpg.webp`;
    },
  },
  filters: {
    formatDisplay: (value) => value || "-",
    formatDisplayMandatory: (value) => value || "This is required.",
    formatMultipleDisplay: (value) => {
      if (value) {
        return Array.isArray(value) ? value.join(", ") : value;
      }
      return "-";
    },
    formatKeyValue: (keyValue) => {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1
        ? keyValue.split(" - ")[1]
        : "-";
    },
    formatKeyValueMandatory: (keyValue) => {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1
        ? keyValue.split(" - ")[1]
        : "This is required.";
    },
    formatTypeOfArrangement: (value) =>
      typeOfArrangementMap[value] || "This is required.",
  },
  methods: {
    ...mapActions([
      types.actions.confirmBookingRemote,
      types.actions.updateBookingField,
      types.actions.setIsVisibleDialogSaveAndExit,
    ]),

    onClickTab(tab, event) {
      this.activeTabName = parseInt(tab.name);
      this.activeContactID = this.contacts[this.activeTabName].contactID;
    },

    onSelectContact(selectedContact) {
      const index = this.contacts.findIndex(
        (contact) => contact === selectedContact,
      );
      if (index < 0) {
        return;
      }
      console.log("onSelectContact index:", index);
      this.activeTabName = index;
      this.activeContactID = this.contacts[this.activeTabName].contactID;
    },

    onContactInputChange(contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      const value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });
    },
    // onClickSave: function(contact) {
    //   this.updateContactRemote({ contact })
    //     .then(res => {
    //       this.$message.success(`Guest's details have been updated successfully!`);
    //     })
    //     .catch(error => {
    //       this.$message.error(`${error}`);
    //     })
    // },

    onClickNextGuest() {
      this.activeTabName++;
      VueScrollTo.scrollTo("#confirmation-summary", 500);
    },

    onCheckedConfirmedBy(checkedInConfirmedBy) {
      this[types.actions.updateBookingField]({
        fieldName: "checkedInConfirmedBy",
        value: checkedInConfirmedBy,
      });
    },

    checkGuestOrAgent(radioButton) {
      if (radioButton === "Agent") {
        return `<a href="https://www.aquaexpeditions.com/travel-professionals/agency-booking-policies/" target="_blank">terms and conditions (for agents)</a>`;
      }
      return `<a href="https://www.aquaexpeditions.com/booking-policies/" target="_blank">terms and conditions</a>`;
    },

    onClickNext() {
      this.$refs.formValidate
        .validate()
        .then(() => {
          console.log(
            "this.getTotalProgressData():",
            this.getTotalProgressData(),
          );

          const totalProgressData = this.getTotalProgressData();
          if (totalProgressData.percentage !== 100) {
            this.contactNamesWithEmptyFields = totalProgressData.emptyFields
              .map((emptyField) => emptyField.contactID)
              .filter((a) => a)
              .filter((elem, index, arr) => arr.indexOf(elem) === index)
              .map((contactID) => {
                // Collect all empty fields under their respective contacts
                let fields = totalProgressData.emptyFields
                  .filter((emptyField) => emptyField.contactID === contactID)
                  .map((emptyField) => {
                    return { label: startCase(emptyField.field), children: [] };
                  });
                return {
                  label: this.getFullName(this.contact(contactID)),
                  children: fields,
                };
              });
            this.isVisibleDialogError = true;

            // this.contactNamesWithEmptyFields = contactNamesWithEmptyFields
            // const contactFullNamesDisplay = `${contactFullNamesWithEmptyField.slice(0, -1).join(', ')}${contactFullNamesWithEmptyField.length > 1 ? ' and ' : ''}${contactFullNamesWithEmptyField.slice(-1)}` /* convert [a,b,c] to 'a, b and c' */
            // this.$message.error(`Please note that one or more required fields for guest ${contactFullNamesDisplay} are missing. Please select the guest's name(s) to fill in all the required information.`)

            return;
          }

          const {
            contacts,
            visaRequirements,
            passports,
            cabinConfigurations,
            booking,
            preArrangements,
            postArrangements,
          } = this;

          this[types.actions.confirmBookingRemote]({
            contacts,
            visaRequirements,
            passports,
            cabinConfigurations,
            booking,
            preArrangements,
            postArrangements,
          })
            .then((res) => {
              this.$router.push("completed");
            })
            .catch((error) => {
              this.$message.error(error.message || UNHANDLED_ERROR_MESSAGE);
            });

          // return Promise.all([
          //   this[types.actions.updateCabinConfigurationRemote]({ cabinConfigurations }),
          //   this[types.actions.updateContactsAndVisaRequirementsRemote]({ contacts, visaRequirements }),
          //   this[types.actions.updatePrePostArrangementsRemote]({ prePostArrangements: preArrangements.concat(postArrangements) }),
          //   this[types.actions.updateBookingRemote]({ booking }),
          // ]).then((data) => {
          //   console.log("data:", data);
          //
          //   this[types.actions.confirmBookingRemote]({ booking })
          //     .then(res => {
          //       this.$router.push('completed')
          //     })
          //     .catch(error => {
          //       this.$message.error(`${error}`);
          //     })
          // })
        })
        .catch((error) => {
          console.log("validate error:", error);
          VueScrollTo.scrollTo("#confirm-details-radio", 500);
          this.$message.error("Please confirm that the details are correct");
        });

      // const booking = this.booking
      // console.log("booking:", booking);
      // this.updateBookingRemote({ booking })
      //   .then(res => {
      // this.$message.success(`Booking's details have been updated successfully!`);
      // })
      // .catch(error => {
      //   this.$message.error(`${error}`);
      // })
    },

    onClickBack() {
      this.$router.back();
    },

    handleScroll() {
      this.isStickySelectContainer =
        window.pageYOffset > this.selectContainerOffsetTop;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.v-select .vs__dropdown-toggle {
  background-color: #fff;
}

.main__confirmation {
  .el-tabs--top {
    .el-tabs__nav {
      width: 100%;
      display: flex;
    }

    .el-tabs__active-bar {
      background-color: unset;
    }

    .el-tabs__item {
      height: unset;
      min-height: 76px;
      padding: 0;
      flex-basis: 0;
      flex-grow: 1;
      width: 0;
    }

    .el-tabs__header.is-top {
      margin-bottom: 0;
      border-radius: 4px 4px 0 0;
      background-color: $aqua-grey-100;
    }

    .tab-pane {
      &__label {
        padding: 24px;
      }

      &__guest-wrapper {
        display: flex;
        flex-direction: column;
        padding: 12px 24px;
      }
    }

    .is-active {
      .tab-pane__label {
        .tab-pane__guest-wrapper {
          background-color: $white-15;
        }
      }
    }
  }

  .el-tabs__content {
    border: 1px solid $aqua-grey-75;
    border-width: 0 1px 1px 1px;
    border-radius: 0 0 4px 4px;
  }

  .dialog--error {
    .el-dialog {
      min-width: 834px;
      border-radius: 4px;

      &__body {
        padding: 80px 84px;
        @include typo-bold(24);
        color: $text-normal-color;

        ul {
        }
      }
    }
  }

  .summary__missing-field-tree {
    margin-top: 52px;
    margin-bottom: 112px;

    .el-tree-node__content {
      margin-top: 24px;
    }

    .el-tree-node__expand-icon {
      color: #4984a3;
      font-size: 21px;
    }

    .el-tree-node__label {
      @include typo-bold(24);
      color: $text-normal-color;
    }

    .el-tree-node__children {
      .el-tree-node__label {
        @include typo(18);
        line-height: 36px;
      }

      .el-tree-node__content {
        margin-top: 16px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

h3 {
  margin: 0;
}

.summary {
  color: $text-normal-color;

  &__header {
    position: relative;
    height: 400px;
    margin-bottom: 24px;
    border-radius: 4px;

    img {
      width: 100%;
      height: 400px;
      object-fit: cover;
      border-radius: 4px;
    }

    &__info {
      padding: 40px 40px 24px 40px;
      background-color: $aqua-grey-100;
      position: absolute;
      bottom: 24px;
      left: 24px;
      right: 24px;
      margin: 0 auto;
      border-radius: 4px;
    }
  }

  &__cruise-name {
    @include desktop-title-title4;
    color: $white-100;
  }

  &__booking-number {
    text-align: right;

    &__label {
      @include global-paragraph-small-regular;
      color: $white-100;
    }

    &__value {
      margin-top: 2px;
      @include global-paragraph-x-large-bold;
      color: $white-100;
    }
  }

  &__contact-list {
    margin-top: 52px;
    margin-bottom: 112px;
    padding: 0;
    list-style-type: none;
  }

  &__contact-list-item {
    margin-bottom: 12px;
  }

  &__contact-list-item-content {
    display: inline-block;
    margin-bottom: 12px;
  }

  &__contact-field-list {
    @include typo(18);
    line-height: 36px;
    list-style-type: none;
  }
}

.tab-pane {
  &__guest-index {
    @include global-paragraph-medium-regular;
    color: $white-100;
  }

  &__guest-name {
    padding-top: 4px;
    @include global-paragraph-large-bold;
    color: $white-100;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

#confirmation-summary {
  &.additionalPaddingTop {
    padding-top: 120px;
  }
}

.select-container {
  width: 100%;
  padding: 24px 40px;
  background-color: $aqua-grey-100;
  border-radius: 4px 4px 0 0;

  label {
    display: block;
    margin-bottom: 8px;
    @include global-paragraph-small-regular;
    color: $white-100;
  }

  &.sticky {
    position: fixed;
    max-width: 1152px;
    top: 0;
    box-shadow: 0 4px 8px -4px $shadow-grey;
    z-index: 1;
  }
}

.confirm-details {
  margin-top: 38px;
  padding: 0 40px 20px 40px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid $aqua-grey-75;

  &__label {
    @include global-paragraph-medium-regular;
    color: $aqua-grey-100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmationPage.vue